import NewsAuthored from "./news-authored.vue";

window.Vue.createApp({
    components: {
        NewsAuthored,
    },
}).mount("#authored-container");
